import { render, staticRenderFns } from "./RangesTable.vue?vue&type=template&id=b503a9fc"
import script from "./RangesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RangesTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports